import { useEffect } from "react";
import { NotificationInstance } from "@timeedit/ui-components/antd/notification/interface";
import {
  CapitalizedNoticeType,
  NotificationState,
  severityTypeMap,
} from "./types";
import { CopyButton } from "../components/Copy/CopyButton";
import { SeverityIcon } from "../components/SeverityIcons";
import { isDefined, stringHasContent } from "@timeedit/registration-shared";
import "./UseNotification.scss";

type useNotificationProps = {
  notificationApi: NotificationInstance;
  notificationState: NotificationState;
  copy: string;
};

export function useNotification({
  notificationApi,
  notificationState,
  copy,
}: useNotificationProps): void {
  useEffect(() => {
    const { description, type, title, technicalInfo } = notificationState;
    if (!stringHasContent(title)) return;

    const severityType: CapitalizedNoticeType = severityTypeMap[type];

    const clipboardText = (): string => {
      return ` URL: ${window.location.href} \n Title: ${title} \n Description: ${description} \n TechnicalInfo: ${technicalInfo}`;
    };

    notificationApi[type]({
      // Required props within TEUI
      placement: "topRight",
      duration: 0,
      closable: true,
      className: "use-notification",

      // Content
      message: title,
      description,
      icon: <SeverityIcon type={severityType} />,
      actions: type !== "success" && isDefined(technicalInfo) && (
        <CopyButton buttonText={copy} clipboardText={clipboardText} />
      ),
    });
  }, [notificationApi, notificationState, copy]);
}
